export default "__VITE_ASSET__C5wioIP7__"